import React from "react";
// Components
import VerifyToken from "../../config/verifyToken";
import { Main } from "../generalStyle";
import Header from "../../components/header";
import ReportsView from "../../components/reports";
import StickyLogo from "../../components/stickyLogo";

const Reports = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <ReportsView />
    </Main>
  </>
);

export default Reports;
